module.exports = {
      id: "v-plus-logo-usage",
      viewBox: "0 0 165.404 72.698",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#v-plus-logo",
      toString: function () {
        return this.url;
      }
    }